import useSize from '@react-hook/size'
import type {RefObject} from 'react'
import {useRef} from 'react'

/**
 * wrapper around useSize hook to get width of the element
 */
export const useElementWidth = <T extends HTMLElement = HTMLDivElement>(): [
  RefObject<T>,
  number
] => {
  const ref = useRef<T>(null)
  const [width] = useSize(ref)
  return [ref, width]
}
